export default [
  {
    path: '/exchangePurchase',
    name: 'exchangePurchase',
    meta: {
      hideTab:true
    },
    component: () => import('@/views/exchangePurchase/index.vue')
  },
  {
    path: '/exchangeGoods',
    name: 'exchangeGoods',
    meta: {
      hideTab:true
    },
    component: () => import('@/views/exchangePurchase/exchangeGoods.vue')
  }
]